import { create } from "zustand";
import { createStoreWithSelectors } from "./createStoreWithSelectors";

export enum SortByOptions {
  PriceAscending = "PriceAscending",
  PriceDescending = "PriceDescending",
  BedroomsAscending = "BedroomsAscending",
  BedroomsDescending = "BedroomsDescending",
  WidthAscending = "WidthAscending",
  WidthDescending = "WidthDescending",
}

interface SortByState {
  sortBy: SortByOptions;
  setSortBy: (sortBy: SortByOptions) => void;
}

const sortByInitialValues = {
  sortBy: SortByOptions.PriceAscending,
};

const sortByStore = create<SortByState>()((set) => ({
  ...sortByInitialValues,
  setSortBy: (sortBy) => set(() => ({ sortBy })),
}));

export const useSortByStore = createStoreWithSelectors(sortByStore);
